import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import Text from '@shared/components/content/text';
import { generatePath } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../../purchased-goods-routes';
import ExcludedItemsToolbar from '../components/excluded-items-toolbar';
import ExcludedOtherTab from '../other/excluded-other-tab';
import {
  excludedItemsConfig,
  excludedItemsHref,
  ExcludedItemType,
} from '../tabs';
import ExcludedReviewTab from '../review/excluded-review-tab';

interface ExcludedItemsCategoryPageProps {
  type: ExcludedItemType;
}

/**
 * Standalone subpage for one excluded-items category, reached from the Excluded
 * items landing cards (e.g. Purchased goods › Excluded items › Other goods).
 * Renders the shared filter toolbar plus the category's listing.
 */
export default function ExcludedItemsCategoryPage({
  type,
}: ExcludedItemsCategoryPageProps) {
  const { title, description } = excludedItemsConfig[type];

  return (
    <Page name={title} title={title}>
      <PageHeader
        name={title}
        breadcrumbs={[
          {
            label: 'Purchased goods',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK),
          },
          {
            label: 'Excluded items',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_EXCLUDED_ITEMS),
          },
          {
            label: title,
            url: generatePath(excludedItemsHref(type)),
          },
        ]}
      />
      <Text variant="subtle" className="-mt-2 mb-4 max-w-2xl">
        {description}
      </Text>
      {/* Match the toolbar→table gap DataTable uses internally (gap-2.5),
          since the toolbar lives outside the listing's DataTable. */}
      <div className="flex flex-col gap-2.5">
        <ExcludedItemsToolbar />
        {type === 'review' ? <ExcludedReviewTab /> : <ExcludedOtherTab />}
      </div>
    </Page>
  );
}
